import * as gqlTypes from "@hydrologiq/gql-experience/graphql"
import { VStack, Text, Heading } from "@chakra-ui/react"
import { IANATimeZone } from "@hydrologiq/common/helpers/date"
import { DateTime, utc, zone } from "timezonecomplete"
import { ActivityCreateProps } from "./screens"
import {
  useCreateFormData,
  useActivityWorkflowActions,
  useLinkableActivitiesCache,
} from "@hydrologiq/shared/contexts/ActivityWorkflowContextV2"
import ActivityLinkSelector from "../ActivityLinkSelector"
import ActivityCreateScreenWrapper from "./ActivityCreateScreenWrapper"
import FormContainer from "@hydrologiq/shared/chakra/custom/FormContainer"

interface ActivityCreateConnectProps extends ActivityCreateProps {
  asset?: gqlTypes.Asset
}

const ActivityCreateConnect = ({
  asset,
  onScreenChange, // eslint-disable-line @typescript-eslint/no-unused-vars
  onBack, // eslint-disable-line @typescript-eslint/no-unused-vars
  onChange, // eslint-disable-line @typescript-eslint/no-unused-vars
  onClose, // eslint-disable-line @typescript-eslint/no-unused-vars
}: ActivityCreateConnectProps) => {
  const createFormData = useCreateFormData()
  const { updateCreateFormField, setLinkableActivitiesCache } = useActivityWorkflowActions()
  const linkableActivitiesCache = useLinkableActivitiesCache()

  if (!createFormData) return null

  return (
    <ActivityCreateScreenWrapper>
      <FormContainer loading={false} canSubmit={true} useFormTag={true}>
        <VStack gap={4} align="stretch">
          <Heading size="md" as="h3">
            Connect activities
          </Heading>
          <Text fontSize="sm" color="fg.muted">
            Connect this movement to related activities to automatically inherit related information.
          </Text>

          <ActivityLinkSelector
            mode="create"
            links={createFormData.links}
            assetId={createFormData.attributes.asset || asset?.id || undefined}
            dateRange={
              createFormData.start && createFormData.end
                ? {
                    start: new DateTime(createFormData.start, "YYYY-MM-DD'T'HH:mm", zone(IANATimeZone()))
                      .toZone(utc())
                      .toIsoString(),
                    end: new DateTime(createFormData.end, "YYYY-MM-DD'T'HH:mm", zone(IANATimeZone()))
                      .toZone(utc())
                      .toIsoString(),
                  }
                : undefined
            }
            cachedLinkableActivities={linkableActivitiesCache}
            onLinkableActivitiesFetched={(before, after, cacheKey) => {
              setLinkableActivitiesCache({ before, after, cacheKey })
            }}
            onLinkCreated={(targetActivityId, linkType, activity, removed, siteId) => {
              if (removed) {
                const removedLink = createFormData.links.find(
                  (link) => link.targetActivityId === targetActivityId && link.linkType === linkType
                )
                updateCreateFormField(
                  "links",
                  createFormData.links.filter((link) => link.targetActivityId !== targetActivityId)
                )

                if (removedLink?.siteId) {
                  const attributeField = linkType === "source" ? "destination" : "source"
                  const currentValue = createFormData.attributes[attributeField]

                  if (currentValue === removedLink.siteId) {
                    updateCreateFormField("attributes", {
                      ...createFormData.attributes,
                      [attributeField]: null,
                    })
                  }
                }
              } else {
                updateCreateFormField("links", [...createFormData.links, { targetActivityId, linkType, siteId }])

                if (siteId) {
                  const attributeField = linkType === "source" ? "destination" : "source"
                  updateCreateFormField("attributes", {
                    ...createFormData.attributes,
                    [attributeField]: siteId,
                  })
                }
                console.log("[ActivityCreateConnect] activity", activity)
                console.log("[ActivityCreateConnect] linkType", linkType)
                switch (linkType) {
                  case "destination":
                    if (activity.quantity_started && activity.quantity_completed) {
                      const quantity = parseFloat(activity.quantity_started) - parseFloat(activity.quantity_completed)
                      updateCreateFormField("quantity_scheduled", quantity.toString())
                      console.log("[ActivityCreateConnect] quantity_scheduled", quantity.toString())
                    }
                    break
                  case "source":
                    if (activity.quantity_scheduled) {
                      updateCreateFormField("quantity_scheduled", activity.quantity_scheduled)
                      console.log("[ActivityCreateConnect] quantity_scheduled", activity.quantity_scheduled)
                    }
                    break
                }
              }
            }}
          />
        </VStack>
      </FormContainer>
    </ActivityCreateScreenWrapper>
  )
}

export default ActivityCreateConnect
